import React from "react";
import MediumHeading from "../UI/MediumHeading";
import "./test.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import sqlImg from "../../assets/certificates_original/sqlHackerRank.jpg";
import javaImg from "../../assets/certificates_original/javaHackerRank.jpg";
import ocaImg from "../../assets/certificates_original/oca.jpg";
import apolloImg from '../../assets/certificates_original/apollo.png';
import saa03 from '../../assets/certificates_original/saa-03.jpg';
import Card from "../UI/Card";
import "../UI/style.css";

const Certificates = () => {
  const settings = {
    dots: true,

    infinite: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div style={{ marginBottom: "80px" }}>
      <div className="mC">
        <MediumHeading text={"Certificates I have obtained"} />
      </div>

      {/*  <div className="scene">
        <div className="cube">
          <div className="side back"></div>
          <div className="side left"></div>
          <div className="side right"></div>
          <div className="side top"></div>
          <div className="side bottom"></div>
          <div className="side front"></div>
        </div>
      </div> */}

      <div style={{ maxWidth: "100%" }}>
        <Card style={{ margin: "auto", borderRadius: "0px" }}>
          <Slider {...settings}>
            <div className="scaleIn">
              <img
                src={sqlImg}
                alt=""
                width="100%"
                height="auto"
                loading="lazy"
              />
            </div>
            <div className="scaleIn">
              <img
                src={saa03}
                alt=""
                width="100%"
                height="auto"
                loading="lazy"
              />
            </div>
            <div className="scaleIn">
              <img
                src={ocaImg}
                alt=""
                width="100%"
                height="auto"
                loading="lazy"
              />
            </div>
            <div className="scaleIn">
              <img
                src={apolloImg}
                alt=""
                width="100%"
                height="auto"
                loading="lazy"
              />
            </div>
            <div className="scaleIn">
              <img
                src={javaImg}
                alt=""
                width="100%"
                height="auto"
                loading="lazy"
              />
            </div>

            {/* <div className="scaleIn">
              <img
                src={es6Img}
                alt=""
                width="100%"
                height="auto"
                loading="lazy"
              />
            </div> */}
           {/*  <div className="scaleIn">
              <img
                src={gitImg}
                alt=""
                width="100%"
                height="auto"
                loading="lazy"
              />
            </div>
            <div className="scaleIn">
              <img
                src={jsImg}
                alt=""
                width="100%"
                height="auto"
                loading="lazy"
              />
            </div>
            <div className="scaleIn">
              <img
                src={phphImg}
                alt=""
                width="100%"
                height="auto"
                loading="lazy"
              />
            </div> */}
          </Slider>
        </Card>
      </div>
    </div>
  );
};

export default Certificates;
